import { useContext, createContext, useReducer } from "react";
import toastReducer from "../reducers/toastReducer";
import setupToast from "../action/toastAction";

const ToastStateContext = createContext({ toasts: [] });
const ToastDispatchContext = createContext(null);

function ToastContextProvider({ children }) {
  const [state, dispatch] = useReducer(toastReducer, { toasts: [] });

  const toast = {
    dispatch,
    error :   (title, element, duration, deleteTime = undefined) => setupToast(dispatch, 'error', title, element, duration, deleteTime),
    success : (title, element, duration, deleteTime = undefined) => setupToast(dispatch, 'success', title, element, duration, deleteTime),
    info:     (title, element, duration, deleteTime = undefined) => setupToast(dispatch, 'info', title, element, duration, deleteTime),
    warning : (title, element, duration, deleteTime = undefined) => setupToast(dispatch, 'warning', title, element, duration, deleteTime)
  }

  return (
    <ToastStateContext.Provider value={state}>
      <ToastDispatchContext.Provider value={toast}>
        {children}
      </ToastDispatchContext.Provider>
    </ToastStateContext.Provider>
  );
}

export default ToastContextProvider;

export const useToastStateContext = () => useContext(ToastStateContext);
export const useToastDispatchContext = () => useContext(ToastDispatchContext);
